import Drawer from '@mui/material/Drawer';
import type { ReactNode } from 'react';
import type { CreativeDetailTab } from '../../../lib/creative-detail-search.js';
import type { DetailCreative } from '../data/api.js';
import { CreativeDetailView } from './CreativeDetailView.js';
import type { CreativeDetailScope } from './data/api.js';

const DRAWER_WIDTH = 820;

interface CreativeDetailDrawerProps {
  creatives: DetailCreative[];
  creativeId: string | null;
  tab: CreativeDetailTab;
  scope: CreativeDetailScope;
  kpis: string[];
  leadingKpiLabel: string;
  contextLabel?: string;
  onOpen: (creativeId: string) => void;
  onTabChange: (tab: CreativeDetailTab) => void;
  onClose: () => void;
}

export function CreativeDetailDrawer({
  creatives,
  creativeId,
  onClose,
  ...viewProps
}: CreativeDetailDrawerProps): ReactNode {
  const creative = creatives.find((entry) => entry.creativeId === creativeId);

  if (creativeId === null || creative === undefined) return null;

  return (
    <Drawer
      anchor="right"
      open
      onClose={onClose}
      slotProps={{ paper: { sx: { width: `min(${DRAWER_WIDTH}px, 100vw)` } } }}
      data-testid="creative-detail-drawer"
    >
      <CreativeDetailView
        creatives={creatives}
        creative={creative}
        onClose={onClose}
        {...viewProps}
      />
    </Drawer>
  );
}
